import { render, staticRenderFns } from "./CardAdd.vue?vue&type=template&id=1280ef49&scoped=true&"
import script from "./CardAdd.vue?vue&type=script&lang=js&"
export * from "./CardAdd.vue?vue&type=script&lang=js&"
import style0 from "./CardAdd.vue?vue&type=style&index=0&id=1280ef49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1280ef49",
  null
  
)

export default component.exports